/* eslint-disable no-undef */
const script = document.querySelector('script[data-webpack-root]');

let publicPath = script?.src?.replace(/\/[^\/?#]+(\?.*)?$/, '/') || './';

publicPath = publicPath.replace(/\/js\/$/, '/');

console.log('[webpack] publicPath gesetzt auf:', publicPath);

if (!script) {
  console.warn('[webpack] Kein <script data-webpack-root> gefunden – fallback auf ./');
}

__webpack_public_path__ = publicPath;
/* eslint-enable no-undef */